import React, { useContext } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { PopperDropdownToggle } from '../../../PopperDropdownLayout';
import { DropdownStateContext } from '../../../DropdownStateManager';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import s from './StandardDropdownToggle.scss';
const StandardDropdownToggle = ({ dropdownId, selectedItem, placeholder, placeholderClassName, toggleClassName, openClassName, arrowClassName, arrowSize, renderArrowDown, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, tabIndex, onOpenBiData, onCloseBiData })=>{
    const { isOpen } = useContext(DropdownStateContext);
    const selectedLabel = get(selectedItem, 'label');
    return /*#__PURE__*/ React.createElement(PopperDropdownToggle, {
        className: classnames(s['toggle'], toggleClassName, !selectedLabel && placeholderClassName, isOpen && openClassName),
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        "aria-controls": dropdownId,
        "aria-haspopup": ariaHasPopup,
        tabIndex: tabIndex,
        onOpenBiData: onOpenBiData,
        onCloseBiData: onCloseBiData
    }, get(selectedItem, 'icon', ''), " ", selectedLabel || placeholder, ' ', renderArrowDown ? renderArrowDown(classnames(s['arrow-icon'], arrowClassName, isOpen && s['is-open'])) : /*#__PURE__*/ React.createElement(ArrowDownIcon, {
        className: classnames(s['arrow-icon'], arrowClassName, isOpen && s['is-open']),
        size: arrowSize,
        disableDefaultColors: true
    }));
};
StandardDropdownToggle.displayName = 'StandardDropdownToggle';
export default StandardDropdownToggle;
